import type { FunctionComponent } from 'react';

import { useChatSlotContent } from '../chat-slot-renderers';
import { useChatComposerActive } from './ChatComposerContext';

// Renders the contextual prompt above the composer. The content comes from the
// feature-registered slot renderers, dispatched by the active chat context.
export const ChatPromptOutlet: FunctionComponent = () => {
    const { activeChatContext } = useChatComposerActive();
    const content = useChatSlotContent('prompt', activeChatContext);

    return <>{content}</>;
};
